import { useMemo } from "react"
import { first } from "lodash"

interface ICinema {
  id: string
  name: string
}

interface IMovieShowTimeConfig {
  options: {
    cinemas: ICinema[]
  }
}

interface IUseMovieShowTimeResult {
  cinemas: ICinema[]
  defaultCinema: ICinema
}

type UseMovieShowTime = (
  config: IMovieShowTimeConfig
) => IUseMovieShowTimeResult

const DEFAULT_CONFIG = {
  options: {
    cinemas: [],
  },
}

export const useMovieShowTimePage: UseMovieShowTime = (
  config: IMovieShowTimeConfig
) => {
  const { options } = config || DEFAULT_CONFIG
  const { cinemas }: { cinemas: ICinema[] } = options
  const defaultCinema = useMemo(() => first(cinemas), [cinemas])
  return { cinemas, defaultCinema }
}
